import { render, staticRenderFns } from "./attr-tbd.vue?vue&type=template&id=115e4a2c&scoped=true&"
import script from "./attr-tbd.vue?vue&type=script&lang=ts&"
export * from "./attr-tbd.vue?vue&type=script&lang=ts&"
import style0 from "./attr-tbd.vue?vue&type=style&index=0&id=115e4a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e4a2c",
  null
  
)

/* custom blocks */
import block0 from "./attr-tbd.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports